import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
    logo: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 20,
    },
}));
